import React, { useState, useEffect, useRef } from "react";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import Button from "components/CustomButtons/CustomButton";
import CustomInput from "components/CustomInput/CustomOutlinedInput";
import CustomSelect from "components/CustomSelect/CustomSelect";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory, useParams } from "react-router-dom";
import AgencyInfo from "./StepsAgency/AgencyInfo";
import CoverageSelection from "./StepsAgency/CoverageSelection";
import SpecialDiscounts from "./StepsAgency/SpecialDiscounts";
import HdiSeguros from "./StepsAgency/HdiSeguros";
import Users from "./StepsAgency/Users";
import Setup from "./StepsAgency/Setup";
import {
  getAgencyDataProfile,
  addBorderAgency,
  deleteBorderAgency,
  saveAgency,
} from "views/Services/AgencyService";
import { Catalogs } from "views/Services/CatalogsService";

import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";

import Wizard from "components/Wizard/WizardRedesign.js";
import CardBody from "components/Card/CardBody";
import { Grid } from "@material-ui/core";

import { sanatizeMessageHtml } from "components/Utils/utils.js";
import CustomModal from "components/CustomModal/Modal.js";
import Snackbar from "components/Snackbar/Snackbar.js";

const useStyles = makeStyles(styles);

export default function AgencyForm({
  agenciesList = [],
  countries = [],
  states = [],
  medicalLimits = [],
  CSLLimits = [],
  specialDiscounts = [],
  optionCross = [],
  users = [],
  onSave,
}) {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();

  useEffect(() => {
    if (localStorage.getItem("userType") !== "1") {
      window.location.href = "/admin/home";
    }

    if (id > 0) {
      getAgencyData(id);
    } else {
      getCatalogsAgency();
    }
  }, [dispatch]);

  useEffect(() => {
    console.log(form);
  }, [form]);

  // Estados para los campos del formulario
  const [tabIndex, setTabIndex] = useState(0);
  const [activeStep, setActiveStep] = useState(0);
  const [messageToast, setMessageToast] = useState("");
  const [toastMessage, setToastMessage] = useState(false);
  const [typeToast, setTypeToast] = useState("danger");
  const [titleModal, setTitleModal] = useState("");
  const [modalSuccess, setModalSuccess] = useState(false);
  const [newAgencyId, setNewAgencyId] = useState(null);
  const wizardRef = useRef(null);

  const classes = useStyles();

  const [form, setForm] = useState({
    producercode: "",
    agencyname: "",
    subagency: false,
    contactname: "",
    address: "",
    country: "",
    state: "",
    masteragency: "",
    city: "",
    zipcode: "",
    phone: "",
    fax: "",
    licensenum: "",
    email: "",
    statelicensed: "",
    csllimit: "",
    specialdiscount: "",
    medicallimit: "",
    dec_to_print: false,
    agency_kiosko: "",
    consumersite: false,
    only_card: false,
    default_premium: false,
    ratepd: false,
    ratetheft: false,
    ratecsl: false,
    rateliab_bi: false,
    rateliab_pd: false,
    ratemedical: false,
    ratelegal_aid: false,
    rateroadside: false,
    ratecaravans: false,
    ratearriba: false,
    rategap: false,
    ratepremiere: false,
    ter_ext: false,
    kiosko: false,
    discount_sentri: false,
    discount_sansonora: false,
    discount_stbaom: false,
    discount_resident: false,
    discount_sobaom: false,
    discount_driverlic: false,
    discount_combuss: false,
    discount_allmexico: false,
    discount_sonora: false,
    discount_baja_only: false,
    discount_sanborns_baja_only: false,
    discount_caravan: false,
    discount_sanborns_sonora_baja: false,
    discount_sonora_baja: false,
    discount_arriba: false,
    agent_type_id: "",
    time_zone: "",
    effectivedate: "",
    expirationdate: "",
    hours_opp1: "",
    hours_opp2: "",
    day_start: "",
    day_end: "",
    notes_operations: "",
    comments: "",
    expirationdatelicense: "",
    eo_policy_number: "",
    expirationdate_eo: "",
    default_border_crossing: "",
    is_active: false,
    minpremium: "",
    commission: "",
    consumercom: "",
    shortpolfee: "",
    midpolfee: "",
    longpolfee: "",
    shortagentfee: "",
    midagentfee: "",
    longagentfee: "",
    surcharge: "",
    minpd: "",
    mintheft: "",
    canceldays: "",
    agency_fee: "",
    agencies: [],
    countries: [],
    states: [],
    medicalLimits: [],
    CSLLimits: [],
    special_discounts: [],
    optioncross: [],
  });

  const updateFormData = (agencyData) => {
    const updatedForm = {
      producercode: agencyData?.agency_item?.producer_code || "",
      agencyname: agencyData?.agency_item?.agency_name || "",
      subagency: agencyData?.agency_item?.subagency === "1",
      contactname: agencyData?.agency_item?.contact_name || "",
      address: agencyData?.agency_item?.address || "",
      country: agencyData?.agency_item?.country_id || "",
      state: agencyData?.agency_item?.state_id || "",
      masteragency: agencyData?.agency_item?.master_agency_id || "",
      city: agencyData?.agency_item?.city || "",
      zipcode: agencyData?.agency_item?.zipcode || "",
      phone: agencyData?.agency_item?.phone || "",
      fax: agencyData?.agency_item?.fax || "",
      licensenum: agencyData?.agency_item?.license_number || "",
      email: agencyData?.agency_item?.email || "",
      statelicensed: agencyData?.agency_item?.state_licensed || "",
      csllimit: agencyData?.agency_item?.csl_limit || "",
      specialdiscount: agencyData?.agency_item?.specialdiscount || "",
      medicallimit: agencyData?.agency_item?.medical_limit || "",
      dec_to_print: agencyData?.agency_item?.dec_to_print === "1",
      agency_kiosko: agencyData?.agency_item?.agency_kiosko || "",
      consumersite: agencyData?.agency_item?.consumersite === "1",
      only_card: agencyData?.agency_item?.only_card === "1",
      tax_id: agencyData?.agency_item?.tax_id || "",
      default_premium: agencyData?.agency_item?.default_premium === "1",
      ratepd: agencyData?.agency_item?.rate_pd === "1",
      ratetheft: agencyData?.agency_item?.rate_theft === "1",
      ratecsl: agencyData?.agency_item?.rate_csl === "1",
      rateliab_bi: agencyData?.agency_item?.rate_liab_bi === "1",
      rateliab_pd: agencyData?.agency_item?.rate_liab_pd === "1",
      ratemedical: agencyData?.agency_item?.rate_medical === "1",
      ratelegal: agencyData?.agency_item?.rate_legal_aid === "1",
      rateroadside: agencyData?.agency_item?.rate_roadside === "1",
      ratecaravans: agencyData?.agency_item?.rate_caravans === "1",
      ratearriba: agencyData?.agency_item?.ratearriba === "1",
      rategap: agencyData?.agency_item?.rate_gap === "1",
      ratepremiere: agencyData?.agency_item?.rate_premiere === "1",
      ter_ext: agencyData?.agency_item?.ter_ext === "1",
      kiosko: agencyData?.agency_item?.kiosko === "1",
      discount_sentri: agencyData?.agency_item?.discount_sentri === "1",
      discount_sansonora: agencyData?.agency_item?.discount_sansonora === "1",
      discount_stbaom: agencyData?.agency_item?.discount_stbaom === "1",
      discount_resident: agencyData?.agency_item?.discount_resident === "1",
      discount_sobaom: agencyData?.agency_item?.discount_sobaom === "1",
      discount_driverlic: agencyData?.agency_item?.discount_driverlic === "1",
      discount_combuss: agencyData?.agency_item?.discount_combuss === "1",
      discount_allmexico: agencyData?.agency_item?.discount_allmexico === "1",
      discount_sonora: agencyData?.agency_item?.discount_sonora === "1",
      discount_baja_only: agencyData?.agency_item?.discount_baja_only === "1",
      discount_sanborns_baja_only:
        agencyData?.agency_item?.discount_sanborns_baja_only === "1",
      discount_caravan: agencyData?.agency_item?.discount_caravan === "1",
      discount_sanborns_sonora_baja:
        agencyData?.agency_item?.discount_sanborns_sonora_baja === "1",
      discount_sonora_baja:
        agencyData?.agency_item?.discount_sonora_baja === "1",
      discount_arriba: agencyData?.agency_item?.discount_arriba === "1",
      agent_type_id: agencyData?.agency_item?.agent_type_id || "",
      time_zone: agencyData?.agency_item?.time_zone || "",
      effectivedate: agencyData?.agency_item?.effectivedate || "",
      expirationdate: agencyData?.agency_item?.expirationdate || "",
      hours_opp1: agencyData?.agency_item?.hours_opp1 || "",
      hours_opp2: agencyData?.agency_item?.hours_opp2 || "",
      day_start: agencyData?.agency_item?.day_start || "",
      day_end: agencyData?.agency_item?.day_end || "",
      notes_operations: agencyData?.agency_item?.notes_operations || "",
      comments: agencyData?.agency_item?.comments || "",
      expirationdatelicense:
        agencyData?.agency_item?.expirationdatelicense || "",
      eo_policy_number: agencyData?.agency_item?.eo_policy_number || "",
      expirationdate_eo: agencyData?.agency_item?.expirationdate_eo || "",
      default_border_crossing:
        agencyData?.agency_item?.default_border_crossing || "",
      is_active: agencyData?.agency_item?.is_active === "1",
      minpremium: agencyData?.CompanyOptions?.minpremium || "",
      commission: agencyData?.CompanyOptions?.commission || "",
      consumercom: agencyData?.CompanyOptions?.consumercom || "",
      shortpolfee: agencyData?.CompanyOptions?.shortpolfee || "",
      midpolfee: agencyData?.CompanyOptions?.midpolfee || "",
      longpolfee: agencyData?.CompanyOptions?.longpolfee || "",
      shortagentfee: agencyData?.CompanyOptions?.shortagentfee || "",
      midagentfee: agencyData?.CompanyOptions?.midagentfee || "",
      longagentfee: agencyData?.CompanyOptions?.longagentfee || "",
      surcharge: agencyData?.CompanyOptions?.surcharge || "",
      minpd: agencyData?.CompanyOptions?.minpd || "",
      mintheft: agencyData?.CompanyOptions?.mintheft || "",
      canceldays: agencyData?.CompanyOptions?.canceldays || "",
      agency_fee: agencyData?.CompanyOptions?.agency_fee || "",
      agencies: agencyData?.agencies || [],
      countries: agencyData?.countries || [],
      states: agencyData?.states || [],
      medicalLimits: agencyData?.medical_limits || [],
      CSLLimits: agencyData?.CSL_limits || [],
      special_discounts: agencyData?.special_discounts || [],
      optioncross: agencyData?.optioncross || [],
      users: agencyData?.users || [],
      ...(agencyData?.optioncross || []).reduce((acc, item, idx) => {
        acc["border_" + (idx + 1)] = item.ba_id != null;
        return acc;
      }, {}),
    };
    setForm(updatedForm);
  };

  const sendBorderCrossData = (checked, indexBorder) => {
    const borderData = {
      agency_id: id || 0,
      border_id: indexBorder,
    };
    const result = checked
      ? dispatch(addBorderAgency(borderData))
      : dispatch(deleteBorderAgency(borderData));
  };

  // Manejo de cambio de campos
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name.startsWith("border_")) {
      sendBorderCrossData(checked, name.split("_")[1]);
    }
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // Manejo de tabs
  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  // Guardar cambios
  const handleSave = async () => {
    let agencyData = { ...form };
    if (id > 0) {
      agencyData.agency_id = id;
    }
    const result = await dispatch(saveAgency(agencyData));
    if (result.payload.result) {
      setTitleModal("Success");
      setMessageToast("Agency saved successfully.");
      setModalSuccess(true);
      if (typeof id === "undefined") {
        setNewAgencyId(result.payload.id);
      }
    } else {
      setMessageToast(
        result.payload.message || "An error occurred while saving."
      );
      setToastMessage(true);
    }
  };

  const getAgencyData = async (agencyId) => {
    const result = await dispatch(getAgencyDataProfile({ id: agencyId }));
    if (result.payload.result) {
      updateFormData(result.payload.data);
    }
  };

  const getCatalogsAgency = async () => {
    const result = await dispatch(
      Catalogs({ userType: localStorage.getItem("userType") })
    );
    if (result.payload.result) {
      setForm((prev) => ({
        ...prev,
        agencies: result.payload.catalogs.agencies || [],
        countries: result.payload.catalogs.countries || [],
        states: result.payload.catalogs.states || [],
        medicalLimits: result.payload.catalogs.medical_limits || [],
        CSLLimits: result.payload.catalogs.CSL_limits || [],
        special_discounts: result.payload.catalogs.special_discounts || [],
      }));
    }
  };

  // Volver atrás
  const handleBack = () => {
    history.push("/admin/agencies");
  };

  // Mantener altura fija para el contenedor del Wizard
  // Calcula la altura máxima de los pasos al montar el componente
  const [wizardHeight, setWizardHeight] = useState(null);
  const stepRefs = useRef([]);

  useEffect(() => {
    // Solo calcula una vez al montar
    if (stepRefs.current.length > 0 && wizardHeight === null) {
      const heights = stepRefs.current.map((ref) => ref?.offsetHeight || 0);
      setWizardHeight(Math.max(...heights));
    }
  }, [form, wizardHeight]);

  const buttonsSave = () => {
    return (
      <GridContainer style={{ marginTop: 20 }}>
        <GridItem
          xs={12}
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <GridItem xs={12} sm={12} md={6}>
            <Button
              variant="green"
              style={{
                width: "100%",
                marginTop: "25px",
              }}
              onClick={() => {
                handleSave();
              }}
            >
              {"Save"}
            </Button>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <Button
              id="backAgenciesButton"
              onClick={() => handleBack()}
              color="success"
              style={{
                backgroundColor: "#FFF",
                borderColor: "#13816F",
                color: "#13816F",
                border: "1px solid",
                marginTop: "25px",
              }}
            >
              {"Back"}
            </Button>
          </GridItem>
        </GridItem>
      </GridContainer>
    );
  };

  // Renderiza cada paso con un ref para medir su altura
  const wizardSteps = [
    {
      stepName: "Agency Information",
      color: "success",
      stepId: "agency_information",
      stepComponent: (
        <div ref={(el) => (stepRefs.current[0] = el)}>
          <AgencyInfo
            form={form}
            handleChange={handleChange}
            agenciesList={form?.agencies || agenciesList}
            countries={form?.countries || countries}
            states={form?.states || states}
            medicalLimits={form?.medicalLimits || medicalLimits}
            CSLLimits={form?.CSLLimits || CSLLimits}
            optionCross={form?.optioncross || optionCross}
            specialDiscounts={form?.special_discounts || specialDiscounts}
            buttonsSave={buttonsSave}
          />
        </div>
      ),
    },
    {
      stepName: "Coverage Selection",
      color: "success",
      stepId: "coverage_selection",
      stepComponent: (
        <div ref={(el) => (stepRefs.current[1] = el)}>
          <CoverageSelection
            form={form}
            handleChange={handleChange}
            buttonsSave={buttonsSave}
          />
        </div>
      ),
    },
    {
      stepName: "Special Discounts",
      color: "success",
      stepId: "special_discounts",
      stepComponent: (
        <div ref={(el) => (stepRefs.current[2] = el)}>
          <SpecialDiscounts
            form={form}
            handleChange={handleChange}
            specialDiscounts={specialDiscounts}
            buttonsSave={buttonsSave}
          />
        </div>
      ),
    },
    {
      stepName: "HDI Seguros",
      color: "success",
      stepId: "hdi_seguros",
      stepComponent: (
        <div ref={(el) => (stepRefs.current[3] = el)}>
          <HdiSeguros
            form={form}
            handleChange={handleChange}
            buttonsSave={buttonsSave}
          />
        </div>
      ),
    },
    {
      stepName: "Users",
      color: "success",
      stepId: "users",
      stepComponent: (
        <div ref={(el) => (stepRefs.current[4] = el)}>
          <Users
            form={form}
            users={form?.users || users}
            agencyId={id}
            handleChange={handleChange}
            buttonsSave={buttonsSave}
          />
        </div>
      ),
    },
    {
      stepName: "Setup",
      color: "success",
      stepId: "setup",
      stepComponent: (
        <div ref={(el) => (stepRefs.current[5] = el)}>
          <Setup
            form={form}
            handleChange={handleChange}
            buttonsSave={buttonsSave}
          />
        </div>
      ),
    },
  ];

  return (
    <div className={classes.container}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={12}>
          <GridContainer
            style={{ padding: "20px 0px 40px 0px" }}
            justify="center"
          >
            <GridContainer>
              <GridItem xs={12} md={12}>
                <GridItem xs={12} md={12}>
                  <Wizard
                    ref={wizardRef}
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                    steps={wizardSteps}
                  />
                </GridItem>
              </GridItem>
            </GridContainer>
          </GridContainer>
        </GridItem>
      </GridContainer>
      <Snackbar
        style={{ zIndex: "3000" }}
        place="center"
        color={typeToast}
        message={messageToast}
        open={toastMessage}
        closeNotification={() => setToastMessage(false)}
        close
      />
      <CustomModal
        title={titleModal}
        isOpen={modalSuccess}
        onClose={() => {
          setModalSuccess(false);
          setMessageToast("");
          if (titleModal === "Success") {
            window.location.href =
              newAgencyId == null
                ? "/admin/agencies"
                : "/admin/agency/" + newAgencyId;
          }
        }}
        privacy={false}
        id={"customerModal"}
      >
        <GridContainer>
          <GridItem xs={12}>
            <h4>
              <div
                dangerouslySetInnerHTML={{
                  __html: sanatizeMessageHtml(messageToast),
                }}
              ></div>
            </h4>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <GridContainer>
              <GridItem xs={0} sm={0} md={2}></GridItem>
              <GridItem xs={12} sm={12} md={8}>
                <Button
                  id="successButton"
                  type="submit"
                  variant="green"
                  onClick={() => {
                    setModalSuccess(false);
                    setMessageToast("");
                    if (titleModal === "Success") {
                      window.location.href =
                        newAgencyId == null
                          ? "/admin/agencies"
                          : "/admin/agency/" + newAgencyId;
                    }
                  }}
                  block
                >
                  Ok
                </Button>
              </GridItem>
            </GridContainer>
          </GridItem>
        </GridContainer>
      </CustomModal>
    </div>
  );
}
